export default __webpack_public_path__ + "static/endava_logo-79e83afa4b92344cf8cd895531a9a415.svg";